import {
    Box,
    Card,
    CardContent,
    CardHeader,
    CircularProgress,
    IconButton,
    Typography,
} from "@mui/material";
import { CheckCircle, Error, Refresh } from "@mui/icons-material";
import { HealthCheckResponse } from "../../interface/returnOps";

interface HealthCheckCardProps {
    healthStatus?: HealthCheckResponse;
    loading: boolean;
    onRefresh: () => void;
}

const HealthCheckCard = ({ healthStatus, loading, onRefresh }: HealthCheckCardProps) => (
    <Card>
        <CardHeader
            title="Health Check"
            action={(
                <IconButton onClick={onRefresh} disabled={loading}>
                    <Refresh />
                </IconButton>
            )}
        />
        <CardContent>
            {loading ? (
                <CircularProgress size={24} />
            ) : healthStatus ? (
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <CheckCircle color="success" />
                    <Typography>Status: {healthStatus.status}</Typography>
                    <Typography variant="body2" color="text.secondary">
                        Last checked: {new Date(healthStatus.timestamp).toLocaleString()}
                    </Typography>
                </Box>
            ) : (
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <Error color="error" />
                    <Typography>Backend is not responding</Typography>
                </Box>
            )}
        </CardContent>
    </Card>
);

export default HealthCheckCard;
